<p-card>
  <app-no-data
    icon="pi pi-clock"
    label="project.steps.previousStepIncompleteTitle"
    description="project.steps.previousStepIncompleteMessage"
  />
</p-card>
